/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import { Box } from '@mui/material'
import SectionHeadline from '../../../../../Header/SectionHeadline'
import MessagingFormGroup from '../../../../../Listings/Listing/Forms/MessagingForm'
import Footer from '../../../../../Listings/Listing/Tabs/Settings/Footer'
import { useOutletContext } from 'react-router-dom'

export function MessagingForm() {
  const formRef = useRef(null)
  const { verificationListing } = useOutletContext()

  if (!verificationListing || !verificationListing.id) {
    return null
  }

  return (
    <div style={{ position: 'relative' }}>
      <Box>
        <Box><SectionHeadline>Customize Messaging</SectionHeadline></Box>
        <Box><MessagingFormGroup innerRef={formRef} listing={verificationListing} isWizard={false} /></Box>
        <Box><Footer label="Save" onSubmit={() => formRef.current.requestSubmit()} /></Box>
      </Box>
    </div>
  )
}

export default MessagingForm
